import { Toaster, Position } from '@blueprintjs/core';

export const AddVehicleToaster = Toaster.create({
  className: 'vehicle-create-toaster',
  position: Position.TOP
});
